export * from "./tiles.address";
//# sourceMappingURL=index.js.map